import { useState } from "react";
import DashboardDetails from "../../components/commonComponent/DashboardCommonComponent/DashboardDetails";
import PlanSetup from "../../components/commonComponent/DashboardCommonComponent/PlanSetup";


const SiteManagerDashboard = () => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (value:boolean): void => {
    setOpen(value);
  };

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Site Manager Dashboard
      </h1>
      <PlanSetup handleClick={handleClick}/>
      {open && 
      <DashboardDetails/>
      }      
    </div>    
  );
};

export default SiteManagerDashboard;
